import { useSelector } from 'react-redux';
import { Permissions, SharedRootStore } from '@cowbell/data';

const defaultConfig = { requireAll: false };

export const useAllow = (
  scopes: Permissions[] | Permissions = [],
  config: typeof defaultConfig = defaultConfig
): boolean => {
  let requiredScopes: Permissions[];
  if (typeof scopes === 'string') {
    requiredScopes = [scopes];
  } else if (Array.isArray(scopes)) {
    requiredScopes = scopes;
  } else {
    requiredScopes = [];
  }

  const scopesListing = useSelector((store: SharedRootStore) => store.scopes);

  if (config.requireAll) {
    return requiredScopes.every((scope) => scopesListing.includes(scope));
  }
  return requiredScopes.some((scope) => scopesListing.includes(scope));
};
